import apiClient from '../clients/apiClient';

export interface PrintFieldSettings {
    column_width: string;
    bold: boolean;
}

export interface PrintPolicyConfig {
    // Layout dimensions - optional for Heading and Front Page (handled by backend)
    page_width?: string;
    page_height?: string;
    line_height?: string;
    margin_top?: string;
    margin_bottom?: string;
    margin_left?: string;
    margin_right?: string;
    font_size?: string;
    required_fields: string[];
    // Heading specific fields
    account_type_name_left?: string;
    account_type_name_top?: string;
    account_number_left?: string;
    account_number_top?: string;
    // Front Page specific fields (dynamic)
    [key: string]: any; // For dynamic field settings like { "account_number_left": "5.0cm", "account_number_top": "2.0cm" }
}

export interface PlPrintPolicyCreate {
    passbook_policy_id?: number;
    passbook_type: number | string | null;
    category: string;
    config: string; // JSON string
}

export interface PlPrintPolicyRead extends PlPrintPolicyCreate {
    id: number;
}

const printPolicyService = {
    createOrUpdatePolicy: async (data: PlPrintPolicyCreate): Promise<PlPrintPolicyRead> => {
        const response = await apiClient.post<PlPrintPolicyRead>('/pl-print-policy/', data);
        return response.data;
    },

    getPolicies: async (): Promise<PlPrintPolicyRead[]> => {
        const response = await apiClient.get<PlPrintPolicyRead[]>('/pl-print-policy/');
        return response.data;
    },

    getPolicyConfig: async (passbookType: number | string, category: string, passbookPolicyId?: number): Promise<PlPrintPolicyRead | null> => {
        const response = await apiClient.get<PlPrintPolicyRead>('/pl-print-policy/config', {
            params: {
                passbook_type: passbookType,
                category: category,
                passbook_policy_id: passbookPolicyId
            }
        });
        return response.data;
    },

    backupPolicy: async (): Promise<{ status: string; filename: string }> => {
        const response = await apiClient.post<{ status: string; filename: string }>('/pl-print-policy/backup');
        return response.data;
    },

    getBackups: async (): Promise<string[]> => {
        const response = await apiClient.get<string[]>('/pl-print-policy/backups');
        return response.data;
    },

    restoreBackup: async (filename: string): Promise<{ status: string; detail: string }> => {
        const response = await apiClient.post<{ status: string; detail: string }>('/pl-print-policy/restore', { filename });
        return response.data;
    }
};

export default printPolicyService;
